<template>
  <div class="modal fade modal-transfer" id="modal-transfer" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <!-- <h4 class="modal-title"> -->
            <div class="inline">
              <img src="../../static/CarteiraEnvia.svg" alt="" width="70">
              <img src="../../static/Transferencia_verde.png" alt="" width="70">
              <img src="../../static/CarteiraEnvia.svg" alt="" width="70">
            </div>
            <div class="inline">
              <h1>move mais transferência de saldo</h1>
              <h4>Precisando de créditos e não tem como fazer uma recarga?</h4>
            </div>
            <h4>Faça sua recarga à distância através da transferência entre contas.</h4>
          <!-- </h4> -->
        </div>
        <div class="modal-body">
          <div id="someTab">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation" class="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab">Descrição</a></li>
              <li role="presentation"><a href="#profile" aria-controls="profile" role="tab" data-toggle="tab">Taxa de serviço</a></li>
              <li role="presentation"><a href="#messages" aria-controls="messages" role="tab" data-toggle="tab">Quem pode</a></li>
              <li role="presentation"><a href="#settings" aria-controls="settings" role="tab" data-toggle="tab">Me ajuda</a></li>
            </ul>

            <!-- Tab panes -->
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="home">
                <h4 class="bold-600 upper">
                  descrição
                  <i class="icon-arrow-major-breadcrumb"></i>
                </h4>
                <div class="pane-answer-box">
                  <p>
                    Agora você poderá receber e transferir saldo para qualquer outro contrato com toda comodidade e praticidade.
                    <br><br>
                    Agora, mesmo quando você estiver sem saldo ou sem poder fazer uma recarga naquele momento, você poderá pedir aos
                    seus amigos e familiares para lhe transferirem o saldo que necessita para passar pelas praças de pedágio automaticamente.
                    <br><br>
                    Este serviço está disponível para todos os clientes <b>Pré-pagos</b> Pessoa Física.
                    <br><br>
                    Para mais informações, leia o <a href="/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais" target="_blank" title="Termos e Condições">Termo de Uso do Serviço</a>.
                  </p>
                </div>
              </div>

              <div role="tabpanel" class="tab-pane" id="profile">
                <h4 class="bold-600 upper">
                  taxa
                  <i class="icon-arrow-major-breadcrumb"></i>
                </h4>
                <div class="pane-answer-box">
                  <p>
                    A taxa de serviço é de <b>2%</b> sobre o valor a ser transferido.
                    <br><br>
                    O contrato de origem tem que ter saldo igual ou maior à soma do valor a ser transferido mais o valor da taxa de serviço.
                    Se tiver, qualquer valor de transferência é permitido.
                  </p>
                  <div class="simulation margin-t20">
                    <h3 class="inline">Fazer simulação</h3>
                    <div class="form-group info-transfer-box inline">
                      <p class="no-margin">Valor da Transferência (R$)*:</p>
                      <button type="button" name="button" class="inline bold btn-charge btn-charge-minus" @click="decrement()">
                        <i class="icon-minus"></i>
                      </button>
                      <input type="text" name="" class="inline form-control bold" placeholder="0,00" @input="changeTransferValue($event.target.value)" :value="transferValue">
                      <button type="button" name="button" autofocus="autofocus" class="inline bold btn-charge btn-charge-plus" @click="increment()">
                        <i class="icon-plus"></i>
                      </button>
                    </div>

                    <div class="form-group percentual-box inline">
                      <p class="no-margin">*Taxa de Transferência (2% sobre o valor) R$:</p>
                      <input class="form-control" type="text" name="" value="" readonly="readonly" v-model="taxTransferValue">
                    </div>

                    <div class="form-group total-box inline">
                      <p class="no-margin">Transferência + Taxa (R$):</p>
                      <input class="form-control" type="text" name="" value="" readonly="readonly" v-model="finalTransferValue">
                    </div>
                  </div>
                </div>
              </div>

              <div role="tabpanel" class="tab-pane" id="messages">
                <h4 class="bold-600 upper">
                  quem pode
                  <i class="icon-arrow-major-breadcrumb"></i>
                </h4>
                <div class="pane-answer-box">
                  <p>
                    Não é preciso contratar esse serviço. Para usar o Move Mais Transferência de Saldo, basta ter saldo em seu plano Pré-pago
                    Pessoa Física com status <b>Ativo</b>.
                    <br><br>
                    O cliente que atender aos critérios para utilizar o serviço, poderá fazer transferência de saldo entre contratos Move Mais,
                    na mesma conta ou entre contas diferentes.
                    <br><br>
                    Pode receber o crédito da transferência se estiver com status <b>Aguardando Ativação, Ativo, Inadimplente, Bloqueado por
                    saldo </b>e <b>A encerrar</b>.
                    <br><br>
                    Não pode receber a transferência de saldo se o contrato estiver com status <b>Cancelado</b>.
                  </p>
                  <p class="red"><b>IMPORTANTE:</b> A transferência efetivada não poderá ser desfeita.</p>
                </div>
              </div>

              <div role="tabpanel" class="tab-pane" id="settings">
                <h4 class="bold-600 upper">
                  me ajuda
                  <i class="icon-arrow-major-breadcrumb"></i>
                </h4>
                <div class="pane-answer-box">
                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      O que é a Transferência de Saldo?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        Trata-se de um serviço disponibilizado pela Move Mais aos seus clientes Pré-pagos Pessoa Física.
                        O cliente que atender aos critérios para utilizar o serviço, poderá fazer transferência de saldo entre
                        contratos Move Mais, na mesma conta ou entre contas diferentes.
                      </p>
                    </div>
                  </div>

                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      Quem pode solicitar o serviço?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        Cliente Move Mais com situação <b>“Ativo”</b> e contrato Pré-pago Manual ou Pré-pago Automático.
                        A transferência pode ser entre contratos de contas diferentes ou entre contratos de uma mesma conta.
                      </p>
                    </div>
                  </div>

                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      Qual o valor/percentual da taxa de serviço?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        A <b>Taxa</b> cobrada será de <b>2%</b> sobre o valor transferido.
                      </p>
                    </div>
                  </div>

                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      Quem pode receber a transferência?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        Clientes com as seguintes situações: <b>"Aguardando Ativação", "Ativo", "Inadimplente", "Bloqueado por
                        saldo" </b>e <b>"A encerrar"</b>.
                      </p>
                    </div>
                  </div>

                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      Quem não pode receber a transferência?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        Clientes com situação <b>"Cancelado"</b>.
                      </p>
                    </div>
                  </div>

                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      Se houver erro na transferência de saldo, que segurança a MOVE MAIS me oferece?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        Todo o processo de transferência de saldo, desde os dados do receber da transferência quanto o valor,
                        é de inteira responsabilidade de quem o fez. Todo o processo é feito através de senha, de uso exclusivo do
                        titular da conta.
                      </p>
                    </div>
                  </div>

                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      A taxa será descontada do cliente que enviar o crédito ou posso selecionar que o crédito seja descontado do recebedor?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        A taxa de 2% será descontado de quem fizer a transferência (<b>emissor</b>).
                      </p>
                    </div>
                  </div>

                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      Sou Pré-pago automático,  se eu transferir todo o meu saldo será  disparada uma nova recarga?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        Sim! Se você é cliente Pré-pago automático será disparada uma nova recarga caso faça a
                        transferência de todo seu saldo ou após a transferência seu saldo fique abaixo dos 40% do valor
                        estipulado para a recarga automática.
                      </p>
                    </div>
                  </div>

                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      Não sei o CPF ou contrato do favorecido, a Central de Relacionamento poderá informar?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        Não!
                      </p>
                    </div>
                  </div>

                  <div class="question-box margin-b20">
                    <h4 class="bold-600">
                      <i class="icon-arrow-major-breadcrumb"></i>
                      Quem recebeu e quem fez a transferência será notificado?
                    </h4>
                    <div class="answer-box">
                      <p class="line-height-20">
                        Sim! Tanto quem fez a transferência quanto quem receber, será notificado através de SMS da efetivação da operação.
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="">
            <input class="check-terms" id="modal-info" type="checkbox" name="modal-info" value="1" @click="doNotShow()">
            <label for="modal-info" class="label-terms">
              Não mostrar mais esta informação.
            </label>
          </div>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>
<style lang="scss" scoped>
  .question-box {
    h4 {
      margin-bottom:                      20px;
      cursor:                             pointer;
    }
    .icon-arrow-major-breadcrumb {
      display:                            inline-block;
      -o-transition:                      .4s;
      -ms-transition:                     .4s;
      -moz-transition:                    .4s;
      transition:                         .4s;
      &.open {
        -ms-transform:                    rotate(90deg);
        -webkit-transform:                rotate(90deg);
        transform:                        rotate(90deg);
      }
    }
    .answer-box {
      max-height:                         1px;
      overflow:                           hidden;
      border-top:                         1px solid #f2f2f2;
      p {
        padding:                          10px 20px;
      }
      &.open {
        max-height:                       100%;
        -o-transition:                    max-height .8s ease-in;
        -ms-transition:                   max-height .8s ease-in;
        -moz-transition:                  max-height .8s ease-in;
        transition:                       max-height .8s ease-in;
      }
    }
  }

  @media screen and (min-width: 320px) and (max-width: 991px) {
    .modal-transfer {
      .modal-content {
        .modal-body {
          .tab-content {
            .tab-pane {
              > h4 {
                font-size:                          2em;
                color:                              #732A82;
                cursor:                             pointer;
                background: #f1f1f1;
                margin:                             0 0 10px;
                border-radius:                      5px;
                /* vertical-align: middle; */
                padding:                            10px;
                .icon-arrow-major-breadcrumb {
                  display:                            inline-block;
                  color:                              #732A82;
                  -o-transition:                      .4s;
                  -ms-transition:                     .4s;
                  -moz-transition:                    .4s;
                  transition:                         .4s;
                  float:                              right;
                  margin-top:                         4px;
                  &.open {
                    -ms-transform:                    rotate(90deg);
                    -webkit-transform:                rotate(90deg);
                    transform:                        rotate(90deg);
                  }
                }
              }
              .pane-answer-box {
                max-height:                         1px;
                overflow:                           hidden;
                border-top:                         1px solid #f2f2f2;
                p {
                  padding:                          10px 20px;
                }
                &.open {
                  /* height: 100%; */
                  max-height:                       100vh;
                  -o-transition:                    max-height .8s ease-in;
                  -ms-transition:                   max-height .8s ease-in;
                  -moz-transition:                  max-height .8s ease-in;
                  transition:                       max-height .8s ease-in;
                }
                &:last-child.open {
                  max-height:                       200vh;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
<script type="text/javascript">
  import {cents} from '../filters/number';
  export default {

    data() {
      return {
        transferValue: "0.00",
        taxTransferValue: "0.00",
        finalTransferValue: "0.00"
      }
    },

    mounted() {
      if (window.document.webview) {
        $('.tab-content').height('266px');
      }
      //
      // if (!localStorage.hasOwnProperty('modal-info')) {
      //   localStorage.setItem('modal-info', 0);
      // }

      // if (localStorage.getItem('modal-info') != 1) {
      //   $('#modal-transfer').modal('show');
      //   $('#someTab').tab('show');
      // } else {
        $("#modal-info").prop("checked", true);
      // }

      let vm = this;
      let el = $(this.$el);
      // FUNÇÃO PARA FAQ NORMAL
      el.find('.question-box > h4').click(function(){
        el.find('.question-box .open').removeClass('open');
        $(this).find('i').addClass('open');
        $(this).parent().find('.answer-box').addClass('open');
      });
      // FUNÇÃO MENU SANFONA PARA MODAL MOBILE
      el.find('.tab-pane > h4').click(function(){
        el.find('.open').removeClass('open');
        $(this).find('i').addClass('open');
        $(this).parent().find('.pane-answer-box').addClass('open');
      });
    },
    methods: {
      doNotShow() {
        if ($('#modal-info').prop('checked') == true) {
          if (localStorage.getItem('modal-info') == 0) {
            localStorage.setItem('modal-info', 1);
          }
        } else {
          localStorage.setItem('modal-info', 0);
        }
      },
      increment() {
        let value = parseInt(this.transferValue.replace(/[^0-9]/g, ''));
        if (value == '' || value >= 0) {
          value += 1000;
        }

        this.changeTransferValue(value+"");
      },
      decrement() {
        let value = parseInt(this.transferValue.replace(/[^0-9]/g, ''));
        if (value > 1000) {
          value -= 1000;
        }

        this.changeTransferValue(value+"");
      },
      changeTransferValue(newValue) {
        let value = parseInt(newValue.replace(/[^0-9]/g, ''));
        //
        this.transferValue = cents(value);
        let tax = value * 0.02;
        this.taxTransferValue = cents(tax);
        this.finalTransferValue = cents(value + tax);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// modal-transfer.vue?413da5a4